export const isClinicFeatureEnabled = (featureKey, clinicFeatures, clinicFeaturesLoaded) => {
    if (!featureKey) {
        return true;
    }

    if (!clinicFeaturesLoaded) {
        return false;
    }

    return clinicFeatures?.[featureKey] === true;
};

export const getEnabledClinicModules = (modules, clinicFeatures, clinicFeaturesLoaded) =>
    modules.filter((module) =>
        isClinicFeatureEnabled(module.featureKey, clinicFeatures, clinicFeaturesLoaded)
    );
